const headerNavi = $(".header-nav");
const headerNav = headerNavi.not(".static-version");
let w = $(window).width();
const is_mobile = w >= 1023 ? false : true;

if (!is_mobile && $(document).scrollTop() > 65) {
  headerNav.addClass("shrink");
}

$("#navigation .nav-item .nav-link").each(function () {
  const link = $(this);
  if (link.attr("href") === window.location.pathname) {
    link.addClass("active");
  }
});

const navbar = $(".navbar-collapse");
const dis_con = $(".discover-button");
const language_selector = $(".language-selector");
const discover_more = $(".discover-more");
const discoverMenu = $(".discover-menu");
const subMenus = $(".sub-menus");
const parentMenu = $(".parent-menu");
const body = $("body");
const discoverContainer = $(".discover-container");
const dataSubTarget = $("[data-sub-target]");
const animatedHamburger = $(".animated-hamburger");
const navbarCover = $(".navbar");
const allItemofSubMenus = $(".sub-menus *");
const carouselWrapper = $(".hero-placeholder");
const main = $("main");

// To support pages with no hero. Please check newsletter page for example.
const getDiscoverClassElement = () => {
  return carouselWrapper.length ? carouselWrapper : main;
};

const closeSublinks = () => {
  if (subMenus.hasClass("show")) {
    $(".sub-link", ".sub-menu-cover").removeClass("show active");
    $(".sub-menu-container").each(function () {
      var subCovers = $(this).find(".sub-menu-cover").first();
      subCovers.addClass("show active");
      subCovers.find(".sub-link").first().addClass("show active");
    });
  }
};

var threshold = 1200;
var mobileThreshold = 1024;
var initialDiff = w >= threshold ? 1 : -1;
var lastWindowWidth = w;

if (!is_mobile) {
  subMenus.removeClass("closed");

  function showElements(elm) {
    var element = elm;
    element.toggleClass("show");
    let target_id = element.data("sub-target");
    let target = $("[data-sub-menu='" + target_id + "']");
    target.toggleClass("show");

    $(".sub-menu-container").each(function () {
      $(this)
        .find(".sub-menu-cover")
        .first()
        .find(".sub-link")
        .first()
        .addClass("show");
    });
    closeSublinks();
  }

  dataSubTarget.on("click", function (e) {
    e.preventDefault();
    showElements($(this));
  });

  $(".sub-menus, [data-sub-target]").click(function (event) {
    event.stopPropagation();
  });

  //Shrink
  $(window).scroll(function () {
    if ($(document).scrollTop() > 65) {
      headerNav.addClass("shrink");
    } else {
      headerNav.removeClass("shrink");
      if (discoverMenu.hasClass("discover-menu--show")) {
        closeDiscover();
      }
    }

    subMenus.removeClass("show");
    dataSubTarget.removeClass("show");

    closeSublinks();
  });
} else {
  //Shrink mobile
  var lastScrollTop = 0;
  $(window).scroll(function () {
    var st = $(this).scrollTop();
    if (st > lastScrollTop) {
      headerNav.removeClass("mobile-shrink-active");
      headerNav.addClass("mobile-shrink-inactive");
    } else {
      headerNav.removeClass("mobile-shrink-inactive");
      headerNav.addClass("mobile-shrink-active");
    }
    lastScrollTop = st;
    if ($(document).scrollTop() > 40) {
      headerNav.addClass("shrink");
    } else {
      headerNav.removeClass("shrink");
    }

    subMenus.removeClass("show");
    dataSubTarget.removeClass("show");
  });
  allItemofSubMenus.removeClass("show active");

  dataSubTarget.on("click", function (e) {
    e.preventDefault();
    subMenus.addClass("show");
    parentMenu.addClass("passed");
    $(".sub-menu-container:first-of-type")
      .find(".sub-menu-cover:first-of-type")
      .addClass("show");
  });
}

const targertedSubLinks = (event, elm) => {
  var element = elm;

  if (!element.hasClass("active")) {
    event.preventDefault();
  }

  if (is_mobile && element.attr("data-menu")) {
    event.stopPropagation();
    return;
  }

  if (!is_mobile) {
    element.closest(".sub-menu-cover").find(".sub-link").removeClass("active");
    element.addClass("active");
  }

  let target_id = element.data("target");
  let target = $("[data-menu='" + target_id + "']");
  let parent = target.parents(".sub-menu-cover");

  if (target.hasClass("sub-link")) {
    parent.siblings().removeClass("show");
    parent.addClass("show");
    target.siblings().removeClass("show");
    target.addClass("show active");
  } else {
    target.find(".sub-link").removeClass("show");
    target.find(".sub-link").first().addClass("show");
    target.siblings().removeClass("show");

    if (target.find("li").length > 0) {
      target.addClass("show");
    }

    if (!is_mobile) {
      target.find(".sub-link").first().click();
    }
  }

  if (is_mobile) {
    element.closest(".sub-menu-cover").addClass("passed");
  }
};

if (is_mobile) {
  $(".go-back-menu").on("click", function (e) {
    e.preventDefault();
    let element = $(this);
    if (element.hasClass("return-menu")) {
      parentMenu.removeClass("passed");
      discoverContainer.removeClass("active");
    }
    element.closest(".sub-menu-cover").removeClass("show");
    element.parents(".sub-menus").find(".passed").last().removeClass("passed");
  });
  var myCollapsible = document.getElementById("navigation");
  if (myCollapsible) {
    myCollapsible.addEventListener("hide.bs.collapse", function () {
      animatedHamburger.removeClass("open");
      parentMenu.removeClass("passed");
      allItemofSubMenus.removeClass("show active passed");
      body.css("overflow", "visible");
      headerNavi.removeClass("active");
      headerNavi.parent("header").removeClass("active");
      subMenus.addClass("closed").removeClass("show");
      parentMenu.addClass("closed");
      discoverContainer.removeClass("active");
      track("Menu", "Closed", {
        "page-position": "Header",
      });

      closeSublinks();
    });
    myCollapsible.addEventListener("shown.bs.collapse", function () {
      animatedHamburger.addClass("open");
      headerNavi.addClass("active");
      headerNavi.parent("header").addClass("active");
      body.css("overflow", "hidden");
      subMenus.removeClass("closed");
      parentMenu.removeClass("closed");
      discover_more.appendTo(navbar);
      track("Menu", "Opened", {
        "page-position": "Header",
      });
    });
  }

  discover_more.on("click", function (e) {
    e.preventDefault();
    getDiscoverClassElement().toggleClass("discovered");
    if (discoverContainer.hasClass("active")) {
      parentMenu.removeClass("passed");
      discoverContainer.removeClass("active");
    } else {
      parentMenu.addClass("passed");
      discoverContainer.addClass("active");
    }
  });
}

window.is_mobile = is_mobile;

const setDiscoverMenuMargin = (discoverMenuMargin) => {
  document.documentElement.style.setProperty(
    "--discover-menu-height",
    `${discoverMenuMargin}px`
  );
};
